import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { setContrast } from '../componentsUtils';
import { stylesPropType, vmPropTypes } from '../../global-prop-types';
import { postToContainer } from '../../global-utils/HrefUtils';

const clickHref = (e) => {
  const tmpClickhRef = e.target.href;
  if (tmpClickhRef.indexOf('http') > 0 - 1) {
    // it's a url. now compare domains
    const tmpUrl = new URL(tmpClickhRef);
    if (tmpUrl.hostname !== window.location.hostname) {
      // if the domain of the Href and the domain
      postToContainer(e, e.target.href);
    }
  }
};

const DynamicContent = (props) => {
  const {
    content, styles, tableHeaderColor, variant
  } = props;
  if (!content) return null;
  const [contentState, setContentState] = useState(content);
  const ref = useRef();

  const paintTablesHeaders = () => {
    const domParser = new DOMParser();
    const htmlValue = domParser.parseFromString(content, 'text/html');
    const tables = htmlValue.getElementsByTagName('table');
    if (tables?.length > 0) {
      Array.from(tables)?.forEach((tblItem, idx) => {
        // Add table wrapper class and styles
        tables[idx].classList.add('tableData-wrapper');
        tables[idx].style.borderBottomColor = tableHeaderColor;

        // Add table's header (thead) class and styles
        if (tables[idx].firstChild.nodeName === 'THEAD') {
          tables[idx].firstChild.classList.add('tableData-headline');
          tables[idx].firstChild.style.backgroundColor = tableHeaderColor;
          tables[idx].firstChild.style.color = setContrast(tableHeaderColor);
        }

        // Add table's body (tbody) class and styles
        const tbodies = tables[idx].getElementsByTagName('tbody');
        Array.from(tbodies).forEach((tb, tbIdx) => tbodies[tbIdx].classList.add('tableData-body'));
      });
    }
    return String(htmlValue.body.innerHTML);
  };

  useEffect(() => {
    if (tableHeaderColor) {
      const painted = paintTablesHeaders();
      setContentState(painted);
    }
  }, [content]);

  useEffect(() => {
    if (ref?.current) {
      const allHrefs = Array.from(ref?.current?.getElementsByTagName('a')) ?? [];
      allHrefs.forEach((href) => {
        href.removeEventListener('click', clickHref);
        href.addEventListener('click', clickHref);
      });
    }
  }, [ref.current]);

  return (
    <div
      ref={ref}
      className={`dynamic-content ${variant || ''}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: contentState }}
      style={styles?.wrapper}
    />
  );
};

DynamicContent.propTypes = {
  variant: PropTypes.string,
  styles: stylesPropType,
  content: PropTypes.string,
  tableHeaderColor: PropTypes.string,
};

DynamicContent.defaultProps = {
  variant: '',
  content: 'Example for a <b>Bold</b> or <u>Underlined</u> Elements',
  tableHeaderColor: 'grey',
};

DynamicContent.vmPropTypes = {
  variant: vmPropTypes.className,
  styles: { wrapper: vmPropTypes.styles },
  content: vmPropTypes.htmlText,
  tableHeaderColor: vmPropTypes.string,
};

export default DynamicContent;
